import React, {useEffect, useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import OpenIcon from '../img/Arrow.svg';
import {t} from 'react-switch-lang';
import {format, parseISO, isBefore, differenceInCalendarDays} from 'date-fns';

const SectionHeader = ({data, open, toggleOpen, value}) => {
  const [date, setDate] = useState(new Date());

  return (
    <div className="section-header  justify-content-between align-items-center">
      <div className="hover-effect  align-items-center">
        <div
          className="section-icon"
          onClick={(event) => toggleOpen(event)}
          id={value}
        >
          <img
            src={OpenIcon}
            className={`${open && 'open'}`}
            alt="Icon"
            onClick={(event) => toggleOpen(event)}
            id={value}
          />
        </div>
      </div>
      <div className=" px-0 section-header-info">
        {!open ? (
          <Row className="m-0 pt-3 info">
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header"> {t('mitigation-measures.date')}</p>
              <p
                className={`info-data dates  ${
                  data !== undefined && data !== null
                    ? isBefore(new Date(data?.realizationDate), date) &&
                      data?.realizationDate !== 'REALIZED'
                      ? 'red'
                      : differenceInCalendarDays(
                          new Date(data?.realizationDate),
                          date
                        ) >= 0 &&
                        differenceInCalendarDays(
                          new Date(data?.realizationDate),
                          date
                        ) < 3
                      ? 'orange'
                      : 'green'
                    : ''
                }`}
              >
                {data !== null &&
                  format(parseISO(data?.realizationDate), 'dd.MM.yyyy.')}
              </p>
            </Col>
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header">{t('mitigation-measures.method')}</p>
              <p className="info-data">{data?.riskMitigationModeName}</p>
            </Col>
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header">{t('mitigation-measures.proposed')}</p>
              <p className="info-data">{data?.mitigationMeasures}</p>
            </Col>
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header">{t('mitigation-measures.status')}</p>
              <p className="info-data">
                {data?.levelOfMeasureRealization === 'NOTSTARTED'
                  ? t('mitigation-measures.notStarted')
                  : data?.levelOfMeasureRealization === 'INPROGRESS'
                  ? t('mitigation-measures.inProgress')
                  : t('mitigation-measures.realized')}
              </p>
            </Col>
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header">{t('mitigation-measures.person')}</p>
              <p className="info-data">
                {data?.userResponsibleFirstName +
                  ' ' +
                  data?.userResponsibleLastName}{' '}
              </p>
            </Col>
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header">
                {t('mitigation-measures.cost-estimation')}
              </p>
              <p className="info-data">{data?.costEstimationCost}</p>
            </Col>
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header">
                {t('mitigation-measures.charge-of-implementing')}
              </p>
              <p className="info-data">{data?.departmentInChargeName}</p>
            </Col>
          </Row>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
